<button
  mat-icon-button
  [matTooltip]="label"
  (click)="isMenuOpen = !isMenuOpen"
  [intercomTarget]="'toolbar-context-menu-border-style'"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <fa-icon [icon]="['far', 'border-style']"></fa-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeOverlay()"
>
  <div class="context-menu-border-style">
    <div class="context-menu-border-style-label">style</div>
    <div class="context-menu-border-style-line">
      <button
        mat-button
        *ngFor="let style of borderStyles; trackBy: trackByValue; let i = index"
        (click)="onStrokeDashArrayChange(style)"
        [intercomTarget]="'01-context-menu-border-style-92973' + i"
      >
        <div
          class="context-menu-border-style-line-button"
          [ngClass]="{
            'context-menu-border-style-line-button--active': (borderStyle || defaultBorderStyle).borderStyle === style
          }"
          [ngStyle]="{ 'border-bottom-style': style }"
        ></div>
      </button>
    </div>
    <div class="context-menu-border-style-label">thickness</div>
    <mat-slider
      [min]="0"
      [max]="10"
      [step]="1"
      [thumbLabel]="true"
      [value]="(borderStyle ?? defaultBorderStyle).borderWidth"
      [tickInterval]="1"
      (input)="onBorderWidthChange($event)"
      class="context-menu-border-style-thickness"
    ></mat-slider>
  </div>
</ng-template>
